import Avatar from '@mui/material/Avatar'
import Box from '@mui/material/Box'
import type { CellSuccessProps } from '@redwoodjs/web'
import bluby from 'src/images/bluby.webp'
import type { FindProfileImageQuery } from 'types/graphql'

export const QUERY = gql`
  query artistImage {
    artist {
      id
      image {
        src(width: 256)
      }
    }
  }
`

export const Success = ({
  artist,
  size = 64,
}: CellSuccessProps<FindProfileImageQuery>) => {
  const src = artist?.image?.src

  return (
    <Avatar
      src={src || bluby}
      sx={{
        width: size,
        height: size,
      }}
    />
  )
}
